import React, { useState } from 'react';
import { CloudRain, Sun, Thermometer, X, ChevronUp, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function WeatherWidget() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="fixed bottom-6 left-6 z-40 hidden md:block" data-id="element-491">
      <motion.div layout className="bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden w-64" data-id="element-492">
        {/* Header / Minimized State */}
        <div className="bg-blue-50 p-3 flex items-center justify-between cursor-pointer hover:bg-blue-100 transition-colors" onClick={() => setIsExpanded(!isExpanded)} data-id="element-493">
          <div className="flex items-center space-x-3" data-id="element-494">
            <div className="text-blue-500" data-id="element-495">
              <CloudRain className="w-6 h-6" data-id="element-496" />
            </div>
            <div data-id="element-497">
              <div className="text-sm font-bold text-gray-800" data-id="element-498">Kampala</div>
              <div className="text-xs text-gray-500" data-id="element-499">24°C, Light Rain</div>
            </div>
          </div>
          <div className="flex items-center space-x-1 text-gray-400" data-id="element-500">
            {isExpanded ? <ChevronDown className="w-4 h-4" data-id="element-501" /> : <ChevronUp className="w-4 h-4" data-id="element-502" />}
            <button onClick={e => {
            e.stopPropagation();
            setIsVisible(false);
          }} className="hover:text-gray-600 p-1" data-id="element-503">
              <X className="w-4 h-4" data-id="element-504" />
            </button>
          </div>
        </div>

        {/* Expanded State */}
        <AnimatePresence data-id="element-505">
          {isExpanded && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} className="p-4 bg-white border-t border-gray-100" data-id="element-506">
              <div className="flex justify-between items-center mb-4" data-id="element-507">
                <div className="flex items-center text-gray-600 text-sm" data-id="element-508">
                  <Thermometer className="w-4 h-4 mr-1" data-id="element-509" /> Humidity: 78%
                </div>
                <div className="flex items-center text-gray-600 text-sm" data-id="element-510">
                  <Sun className="w-4 h-4 mr-1" data-id="element-511" /> UV: Low
                </div>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3" data-id="element-512">
                <h4 className="text-xs font-bold text-yellow-800 mb-1 uppercase tracking-wider" data-id="element-513">
                  Farming Advisory
                </h4>
                <p className="text-xs text-yellow-700 leading-relaxed" data-id="element-514">
                  Expected rainfall over the next 48 hours. Good time for
                  planting maize and beans in the central region. Ensure proper
                  drainage.
                </p>
              </div>
            </motion.div>}
        </AnimatePresence>
      </motion.div>
    </div>;
}